const API_URL = process.env.REACT_APP_ESTEIRA_BACK;

export interface ILayout {
  logoUrl: string; 
  logoBase64?: string;
  corPrincipal: string;
  corSecundaria: string;
  corTexto: string;
  corCabecalho: string;
  corTabela: string;
}

export const fetchLayoutBySlug = async (slug: string|undefined): Promise<ILayout> => {
  if (!slug) {
    throw new Error("Slug do originador não pode ser nulo.");
  }

  try {
    const response = await fetch(`${API_URL}/api/layouts/${slug}`);

    if (!response.ok) {
      // Redireciona se o status não for 200-299 (ex: 404, 500)
      if(slug !== "undefined"){
        console.log("slug teste", slug)
        window.location.href = '/error-originador'; // Mude para sua rota de erro desejada
      }
      throw new Error(`Erro ao buscar layout: ${response.statusText}`);
    }

    const data: ILayout = await response.json();
    return data;

  } catch (error) {
    
    if (slug !== 'undefined') {
      console.log("slug teste2", slug)
      // Redireciona em caso de erro de rede (Servidor fora do ar) ou o erro acima
      console.error("Erro no fetchLayout:", error);
      window.location.href = '/error-originador'; // Mude para sua rota de erro desejada
      
    }
    throw error;
  }
};